<template>
  <div id="contendor-agregar-archivos-contratista">
    <v-form v-model="formularioValido" ref="formAgregarArchivoContratista">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar Archivo
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-select
              v-model="archivo.idTipoArchivo"
              label="Tipo de Archivo"
              :items="getCatalogoTipoArchivoContratista"
              item-text="descripcion"
              item-value="id"
              cols="12"
              :rules="[mixReglas.requerido]">
            </custom-select>
            <text-field
              cols="12"
              v-model="archivo.descripcion"
              label="Descripción"
              :rules="[mixReglas.requerido]"
            >
            </text-field>
            <date-picker
              v-model="archivo.fecha"
              label="Fecha"
              cols="6"
              :rules="[mixReglas.requerido]"
            >
            </date-picker>
          </v-row>
          <v-row align="center" justify="center">
            <v-btn text large icon class="secondary--text" @click="seleccionarArchivo">
              <v-icon center>
                mdi-paperclip
              </v-icon>
            </v-btn>
            <template v-if="nombreArchivoSeleccionado">
              <span>{{ nombreArchivoSeleccionado }}</span>
            </template>
            <template v-else>
              <span> Seleccionar Archivo </span>
            </template>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="guardar"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
      <v-file-input
        v-show="false"
        show-size
        type="file"
        ref="anexoDocumento"
        name="anexo"
        id="anexo"
        @change="seleccion"
        :rules="[mixReglas.requerido]"
      >
      </v-file-input>
    </v-form>
  </div>
</template>

<script>
import mixArchivosContratista from './mixArchivosContratista';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';
import DatePicker from '@/components/inputs/DatePicker.vue';
import TextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'AgregarArchivosContratista',
  mixins: [mixArchivosContratista, mixSubirArchivo],
  components: {
    TextField,
    DatePicker,
    CustomSelect,
    CustomButton,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      nombreArchivoSeleccionado: null,
      archivo: {
        idContrato: this.idContrato,
        idTipoArchivo: null,
        fecha: new Date().toISOString().substr(0, 10),
        descripcion: null,
        fileData: null,
      },
    };
  },
  methods: {
    async guardar() {
      this.enviandoFormulario = true;
      const datosArchivo = this.setDatosArchivo();
      const archivo = await this.mixSubirArchivo(datosArchivo);
      if (archivo.status === 'ok') {
        this.archivo.fileData = JSON.stringify(archivo.data);
        this.mixAgergarContratoArchivoContratista();
      }
    },
    setDatosArchivo() {
      const datos = {
        nombre: `${this.nombreArchivoSeleccionado}`,
        path: 'Contratistas/Documentos',
      };
      return datos;
    },
    seleccionarArchivo() {
      document.getElementById('anexo').click();
    },
    seleccion() {
      this.nombreArchivoSeleccionado = document.getElementById('anexo').files[0]?.name;
    },
    cerrar() {
      this.$refs.formAgregarArchivoContratista.reset();
      this.$emit('cerrar');
    },
  },
  watch: {
    nombreArchivoSeleccionado: {
      handler() {
        if (!this.archivo.descripcion) {
          const nombre = this.nombreArchivoSeleccionado.replace(/\.[^/.]+$/, '');
          this.archivo.descripcion = nombre;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
